import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useRouteParam } from '@hooks/params';

import {
  insurancePolicyUserFetch,
  InsurancePolicyUserFetchPayload,
  insurancePolicyUserHealthBenefitLimitsFetch,
  InsurancePolicyUserHealthBenefitLimitsFetchPayload,
} from './action';
import { selectInsurancePolicyUserDetails } from './selector';

export const useInsurancePolicyUserFetch = () => {
  const dispatch = useDispatch();
  const insurancePolicyUserId = Number(useRouteParam('insurancePolicyUserId'));
  const { policyUser, healthBenefitLimitsWithAccumulatedPaidAmounts } = useSelector(selectInsurancePolicyUserDetails);

  useEffect(() => {
    const payload: InsurancePolicyUserFetchPayload = { id: insurancePolicyUserId };
    dispatch(insurancePolicyUserFetch(payload));
  }, [insurancePolicyUserId, dispatch]);

  useEffect(() => {
    const payload: InsurancePolicyUserHealthBenefitLimitsFetchPayload = { id: insurancePolicyUserId };
    dispatch(insurancePolicyUserHealthBenefitLimitsFetch(payload));
  }, [insurancePolicyUserId, dispatch]);

  return { policyUser, healthBenefitLimitsWithAccumulatedPaidAmounts };
};
